import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from "lucide-react";
import logo from "@/assets/logo.webp";

const Footer = () => {
  return (
    <footer className="bg-harbor-blue text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" aria-label="Harbor Heights Extended Stay - Home">
              <img
                src={logo}
                alt=""
                aria-hidden="true"
                width={280}
                height={224}
                className="h-36 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-white/80 text-sm leading-relaxed">
              Experience comfortable extended stay accommodations with the comfort of home and attentive service in Sioux City, Iowa.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-4">Quick Links</h3>
            <nav className="space-y-2">
              <Link to="/" className="block text-white/80 hover:text-warm-gold transition-colors text-sm">
                Home
              </Link>
              <Link to="/booking" className="block text-white/80 hover:text-warm-gold transition-colors text-sm">
                Suites & Booking
              </Link>
              <Link to="/about" className="block text-white/80 hover:text-warm-gold transition-colors text-sm">
                About Us
              </Link>
              <Link to="/contact" className="block text-white/80 hover:text-warm-gold transition-colors text-sm">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-4">Contact Us</h3>
            <address className="not-italic space-y-3 text-sm">
              <a
                href="tel:+1-712-224-7003"
                className="flex items-start gap-3 text-white/80 hover:text-warm-gold transition-colors group"
              >
                <Phone className="w-5 h-5 mt-0.5 group-hover:animate-float" />
                <span>(712) 224-7003</span>
              </a>
              <a
                href="mailto:stay@harborheightssiouxcity.com"
                className="flex items-start gap-3 text-white/80 hover:text-warm-gold transition-colors group"
              >
                <Mail className="w-5 h-5 mt-0.5 group-hover:animate-float" />
                <span>stay@harborheightssiouxcity.com</span>
              </a>
              <div className="flex items-start gap-3 text-white/80">
                <MapPin className="w-5 h-5 mt-0.5" />
                <span>
                  6120 Harbor Drive
                  <br />
                  Sioux City, Iowa 51111
                </span>
              </div>
            </address>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-4">Front Desk</h3>
            <div className="text-white/80 text-sm space-y-2 mb-6">
              <p>24/7 Available</p>
              <p className="text-warm-gold">Always here for you</p>
            </div>
            <div>
              <h4 className="font-semibold mb-3 text-sm">Follow Us</h4>
              <div className="flex gap-3">
                <a
                  href="#"
                  className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-warm-gold transition-all duration-300 hover:scale-110"
                  aria-label="Facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-warm-gold transition-all duration-300 hover:scale-110"
                  aria-label="Instagram"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-warm-gold transition-all duration-300 hover:scale-110"
                  aria-label="Twitter"
                >
                  <Twitter className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
            <p>&copy; {new Date().getFullYear()} Harbor Heights Extended Stay. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-warm-gold transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-warm-gold transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;